// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + ".midxh9p7i0c." + {"634":"c505eef0","698":"41f9aa4b","967":"279aa38f","985":"07e7c436"}[chunkId] + ".chunk.css";
};